import React, { useState, useRef, useEffect } from 'react';
import {
    Button, TextField, Typography, IconButton, Snackbar,
    Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import axios from 'axios';

function RenaiEventAttendanceButton({ page, mini, onSubmitAttendance }) {
    const [attended, setAttended] = useState(page.extensionData?.AttendanceData || false);
    const [modalOpen, setModalOpen] = useState(false);

    const onClick = () => {
        setModalOpen(true);
    };

    const onClose = () => {
        setModalOpen(false);
    };

    const onSubmit = () => {
        setModalOpen(false);
        setAttended(true);
        onSubmitAttendance?.(page.id);
    };

    useEffect(() => {
        setAttended(page.extensionData.AttendanceData || false);
    }, [page]);

    return <>
        <Button size="small" style={mini ? { padding: '4px', margin: 0, minWidth: 'auto', fontSize: '0.8rem' } : {}} variant="contained" color="primary" onClick={onClick}>{attended ? 'Review reflection' : 'Record completion'}</Button>
        <RenaiEventAttendanceForm isOpen={modalOpen} page={page} onClose={onClose} onSubmit={onSubmit} showAlert={true} />
    </>;
}

function RenaiEventAttendanceForm({ isOpen, page, onClose, onSubmit, showAlert }) {
    const textarea = useRef(null);
    const [error, setError] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [editing, setEditing] = useState(!page.extensionData?.AttendanceData);
    const [response, setResponse] = useState(null);

    useEffect(() => {
        setEditing(!page.extensionData?.AttendanceData);
    }, [page]);

    useEffect(() => {
        axios.get("api/pageattendances/recordattendance/" + page.family, { }, { withCredentials: true })
            .then(e => {
                setResponse(e.data);
            })
            .catch(e => {
                setError(e.response?.data?.errors?.reflection || "Error");
            });
    }, [page]);

    const handleSubmit = () => {
        setError(null);
        axios.post("api/pageattendances/recordattendance/" + page.family, { reflection: textarea.current.value }, { withCredentials: true })
            .then(() => {
                if (showAlert)
                    setAlertOpen(true);
                onSubmit?.();
            })
            .catch(e => {
                console.log(e.response);
                setError(e.response.data.errors.reflection);
            });
    };

    return <>
        <Dialog open={isOpen} onClose={onClose} aria-labelledby={"renai-attend-dialog-title" + page.id} maxWidth={'md'} fullWidth>
            <DialogTitle aria-labelledby={"renai-attend-dialog-title" + page.id}>Attendance</DialogTitle>
            <DialogContent>
                {editing ? <><Typography variant="body1">Please submit your reflection on your attendance to this event !TODO!</Typography>
                    <TextField inputRef={textarea}
                        id={"renai-attend-content" + page.id}
                        label="Reflection"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        error={!!error}
                        helperText={error}
                        defaultValue={response}
                    /></> : <Typography variant="body1">
                        <IconButton aria-label="edit" onClick={() => setEditing(true)} ><Edit /></IconButton>
                        {response}
                </Typography>}
            </DialogContent>
            <DialogActions>
                {editing && <Button onClick={handleSubmit} color="primary">Submit</Button>}
                <Button onClick={onClose} color="default">{!editing ? 'Ok' : 'Cancel'}</Button>
            </DialogActions>
        </Dialog>
        <Snackbar open={alertOpen} autoHideDuration={5000} onClose={_ => setAlertOpen(false)}>
            <Alert onClose={_ => setAlertOpen(false)} severity="success">
                Reflection submitted successfully
            </Alert>
        </Snackbar>
    </>;
}

export default RenaiEventAttendanceButton;

export { RenaiEventAttendanceButton, RenaiEventAttendanceForm };